const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  fiberImage: {
    maxWidth: '100%',
    display: 'block'
  }
})

export default styles
